export * from "./shadowOnlyMaterial.js";
//# sourceMappingURL=index.js.map